module.exports = __webpack_public_path__ + "static/policy_feedback_germany-667e14420a24919d590a4efacece6c22.png";